import {
  CallToAction,
  OfferBannerConfig,
  offerBannerStateMocks
} from '@com-delta-idp/mnx-fast-action-banner-ui';
import { Image } from '@com-delta-idp/mnx-ui-kit';
import { Banner } from '../models/earns.interfaces';
import { BannerStylesMocks } from './banner/styles.mocks';

export const OfferBannerConfigMocks: OfferBannerConfig = {
  congratulation: false,
  showBenefit: true,
  showAction: true,
  showCreditSummary: false,
  showDetails: false,
  showHeadline: true,
  showLinks: false,
  showOffer: true
};

export const callToAction: CallToAction = {
  input: 'button',
  link: {
    label: 'LEARN MORE',
    url: 'https://apply.americanexpress.com/en-us/delta-spring-bau-march23/page/18#gold'
  },
  secondaryLink: {
    label: 'Terms Apply',
    url: 'https://www.delta.com/goldofferterms'
  },
  linkId: 'goldLearnMore-gold',
  secondaryLinkId: 'goldTermsApply-gold'
};

export const OfferImage: Image = {
  src: '/content/dam/nextgen/nextgenskymiles/pe/amex-banner/gold.png',
  alt: 'Start enjoying special benefits such as your first checked bag free on Delta flights. image'
};

export const BannerMocks: Banner = {
  offer: {
    ...offerBannerStateMocks.offer,
    action: callToAction,
    offer: 'Earn 20,000 Bonus Miles*',
    benefit:
      'Start enjoying special benefits such as your first checked bag free on Delta flights.',
    image: OfferImage,
    cardType: 'gold'
  },
  offerConfig: OfferBannerConfigMocks,
  offerStyles: BannerStylesMocks,
  disabled: false,
  loaded: true
};
